import { SET_PREFERRED_SERVICE_TYPE } from 'actions';
import { ServiceType } from 'typings';

export function setPreferredServiceType(preferredServiceType?: ServiceType) {
  return { preferredServiceType, type: SET_PREFERRED_SERVICE_TYPE };
}
